import { Box } from '@mui/material'
import type { ReactNode } from 'react'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { MetaText } from '@/components/atoms/MetaText'

interface Props {
  // 行頭 marker (・ / ○ / ×). 20px 幅・中央・14px で section 間の行頭位置を視覚統一する.
  marker: ReactNode
  // marker 字色. 既定 = fg.faint (確認要点の「・」/ 非適用加算の「×」).
  // 適用加算の「○」のみ呼び出し側で fg.default を渡す.
  markerColor?: string
  // 主行 (= statement / 加算名). BodyText 等の本文 node を呼び出し側で組む
  // (inline chip を含める場合があるため node 受け).
  main: ReactNode
  // 従行 (= 論拠 / 理由). あれば主の直下に MetaText (12/fg.muted) で落とす.
  sub?: ReactNode
}

// 確認要点 (GuidanceCheckPointCard) と加算 (KasanStatusPanel) で共通の「marker + 主/従」行.
// 2 col grid (marker 20px + content 1fr) で行頭位置を揃え、 content を主 + 従の 2 段に落とす.
// section 間で行頭位置・字色階層が視覚統一される
// (= Notion 引き算: 枠線でなく余白 + 字色階層で構造化).
export const GuidancePrepRow = ({
  marker,
  markerColor = colorTokens.fg.faint,
  main,
  sub,
}: Props) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '20px 1fr',
        columnGap: 1.5,
        alignItems: 'baseline',
      }}
    >
      <Box
        component="span"
        sx={{
          fontSize: 14,
          color: markerColor,
          textAlign: 'center',
          lineHeight: 1.5,
          userSelect: 'none',
        }}
      >
        {marker}
      </Box>
      <Box>
        {main}
        {sub && <MetaText sx={{ mt: 0.25 }}>{sub}</MetaText>}
      </Box>
    </Box>
  )
}
